import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

const BackHeader = ({ title = 'Back', onBack,marginBottom=3,marginLeft=0 }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1); // default to go back one page
    }
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={2}
      mb={marginBottom}
      sx={{ cursor: 'pointer',marginLeft:marginLeft }}
    >
      <IconButton onClick={handleBack}>
        <ArrowBackIcon sx={{color:'white'}} />
      </IconButton>
      <Typography onClick={handleBack} variant="h6" fontWeight={600}>
        {title}
      </Typography>
    </Box>
  );
};

export default BackHeader;
